<template>
  <div>
    <LoadingSpinner v-if="loading"/>

    <div v-else class="panel panel-default">
      <div class="panel-body">
        <form @submit.prevent="submit" class="form-horizontal">
          <TextFormGroup
              v-model="data.name"
              name="name"
              label="Name"
              :error="(errors.name || [])[0]"
          />

          <TextFormGroup
              v-model="data.title"
              name="title"
              label="Title"
              :error="(errors.title || [])[0]"
          />

          <TextFormGroup
              v-model="data.email"
              name="email"
              label="Email"
              :error="(errors.email || [])[0]"
          />

          <TextFormGroup
              v-model="data.phone"
              name="phone"
              label="Phone"
              :error="(errors.phone || [])[0]"
          />

          <GalleryFormGroup
              v-model="data.image_id"
              name="image_id"
              label="Image"
              :error="(errors.image_id || [])[0]"
          />

          <hr>

          <SubmitFormGroup button-class="btn-black"/>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import GalleryFormGroup from '@/components/FormGroups/Horizontal/Gallery'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'
import LoadingSpinner from "../../../../../../components/Layout/LoadingSpinner.vue";

export default {
  components: {
    LoadingSpinner,
    GalleryFormGroup,
    SubmitFormGroup,
    TextFormGroup,
  },

  mixins: [Errors],

  props: {
    contactId: {
      required: true
    }
  },

  data() {
    return {
      data: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      this.loading = true

      http.get('/api/v2/contacts/' + this.contactId)
          .then(response => {
            this.data = response.data.data.attributes

            this.loading = false
          })
    },

    submit() {
      http.put('/api/v2/contacts/' + this.contactId, this.data)
          .then(response => {
            notify.success('The contact was saved')

            this.data = response.data.data.attributes
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
